import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {
  Grade,
  GradeChangeInput,
} from '@/pages/AccountInformation/AccountInformation.types';
import styles from './SelectInput.styles';

interface SelectInputProps {
  label: string;
  childUid: string;
  options: Grade[];
  value: Grade;
  onChange: (input: GradeChangeInput, childUId: string) => void;
}

export const SelectInput: React.FC<SelectInputProps> = ({
  label,
  childUid,
  options,
  value,
  onChange,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const grade = options.find(option => option.id === event.target.value);
    if (grade) {
      onChange(grade, childUid);
    }
  };

  return (
    <div>
      <FormControl variant="standard" fullWidth>
        <InputLabel id={`gradeLabel${childUid}`}>
          {label}
        </InputLabel>
        <Select
          labelId={`gradeLabel${childUid}`}
          id={`gradeInput${childUid}`}
          className={styles.container}
          value={value?.id.toString() || ''}
          onChange={handleChange}
          inputProps={{
            'data-testid': 'gradeInput',
          }}
        >
          {options.map(({ id, description }) => {
            return (
              <MenuItem
                key={id}
                value={id}
                data-testid="gradeOption"
                className={styles.optionItem}
              >
                {description}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
};
